function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { UrlScheme } from './video-platforms.enums';
export { UrlScheme } from './video-platforms.enums';
export var Url = /*#__PURE__*/ function() {
    "use strict";
    function Url() {
        var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, Url);
        _define_property(this, "url", void 0);
        this.url = url;
    }
    _create_class(Url, [
        {
            key: "toString",
            value: function toString() {
                var _Object_keys;
                var _this_url = this.url, scheme = _this_url.scheme, domain = _this_url.domain, path = _this_url.path, params = _this_url.params;
                var schemeString = scheme ? "".concat(scheme, "//") : '';
                var domainString = (domain === null || domain === void 0 ? void 0 : domain.join('.')) || '';
                var pathString = (path === null || path === void 0 ? void 0 : path.join('/')) || '';
                var paramsString = ((_Object_keys = Object.keys(params || {})) === null || _Object_keys === void 0 ? void 0 : _Object_keys.length) ? '?' + Object.entries(params).map(function(v) {
                    return v.join('=');
                }).join('&') : '';
                return "".concat(schemeString).concat(domainString).concat(pathString).concat(paramsString);
            }
        },
        {
            key: "toObject",
            value: function toObject() {
                return this.url;
            }
        },
        {
            key: "addParameter",
            value: function addParameter(key, value) {
                var _this_url_params, _this_url;
                if ((_this_url = this.url) === null || _this_url === void 0 ? void 0 : (_this_url_params = _this_url.params) === null || _this_url_params === void 0 ? void 0 : _this_url_params[key]) {
                    throw new Error("removeParameter - key `".concat(key.toString(), "` already exist"));
                }
                if (this.url.params) {
                    this.url.params = _object_spread_props(_object_spread({}, this.url.params), _define_property({}, key, value));
                } else {
                    this.url.params = _define_property({}, key, value);
                }
                return this;
            }
        },
        {
            key: "setUrlScheme",
            value: function setUrlScheme() {
                var secure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this.url.scheme = secure ? UrlScheme.Https : UrlScheme.Http;
                return this;
            }
        },
        {
            key: "setHttp",
            value: function setHttp() {
                this.url.scheme = UrlScheme.Http;
                return this;
            }
        },
        {
            key: "setHttps",
            value: function setHttps() {
                this.url.scheme = UrlScheme.Https;
                return this;
            }
        },
        {
            key: "setParameter",
            value: function setParameter(key, value) {
                if (this.url.params) {
                    this.url.params = _object_spread_props(_object_spread({}, this.url.params), _define_property({}, key, value));
                } else {
                    this.url.params = _define_property({}, key, value);
                }
                return this;
            }
        },
        {
            key: "transformParameter",
            value: function transformParameter(key, fn) {
                var _this_url_params, _this_url;
                if (!((_this_url = this.url) === null || _this_url === void 0 ? void 0 : (_this_url_params = _this_url.params) === null || _this_url_params === void 0 ? void 0 : _this_url_params[key])) {
                    throw new Error("transformParameter - key `".concat(key.toString(), "` does not exist"));
                }
                this.url.params[key] = fn(this.url.params[key]);
                return this;
            }
        },
        {
            key: "transformParameters",
            value: function transformParameters(fn) {
                var _this_url;
                this.url.params = fn((_this_url = this.url) === null || _this_url === void 0 ? void 0 : _this_url.params);
                return this;
            }
        },
        {
            key: "removeParameter",
            value: function removeParameter(key) {
                var _this_url_params, _this_url, _this_url_params1, _this_url1;
                if (!((_this_url = this.url) === null || _this_url === void 0 ? void 0 : (_this_url_params = _this_url.params) === null || _this_url_params === void 0 ? void 0 : _this_url_params[key])) {
                    throw new Error("removeParameter - key `".concat(key.toString(), "` does not exist"));
                }
                (_this_url1 = this.url) === null || _this_url1 === void 0 ? true : (_this_url_params1 = _this_url1.params) === null || _this_url_params1 === void 0 ? true : delete _this_url_params1[key];
                return this;
            }
        },
        {
            key: "emptyParameters",
            value: function emptyParameters() {
                delete this.url.params;
                return this;
            }
        },
        {
            key: "if",
            value: function _if(condition, callback) {
                if (condition) {
                    callback(this);
                }
                return this;
            }
        }
    ], [
        {
            key: "make",
            value: function make() {
                var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return new Url(url);
            }
        },
        {
            key: "parse",
            value: function parse(url) {
                var match = this.regex.exec(url);
                var _match = _sliced_to_array(match, 5), schemeMatch = _match[1], domainMatch = _match[2], pathMatch = _match[3], paramsMatch = _match[4];
                var scheme = this.getScheme(schemeMatch);
                var domain = domainMatch ? domainMatch.split('.') : [];
                var path = pathMatch ? [
                    ''
                ].concat(_to_consumable_array(pathMatch.split('/'))) : [];
                var paramItems = paramsMatch === null || paramsMatch === void 0 ? void 0 : paramsMatch.split('&');
                var params = (paramItems === null || paramItems === void 0 ? void 0 : paramItems.filter(function(v) {
                    return v;
                }).length) ? paramItems.reduce(function(a, c) {
                    var _c_split = _sliced_to_array(c.split('='), 2), k = _c_split[0], v = _c_split[1];
                    return _object_spread_props(_object_spread({}, a), _define_property({}, k, v));
                }, {}) : undefined;
                return new Url(_object_spread({}, scheme && {
                    scheme: scheme
                }, domain.length && {
                    domain: domain
                }, path.length && {
                    path: path
                }, params && {
                    params: params
                }));
            }
        },
        {
            key: "getScheme",
            value: function getScheme(s) {
                switch(s){
                    case UrlScheme.Http:
                        return UrlScheme.Http;
                    case UrlScheme.Https:
                        return UrlScheme.Https;
                    case UrlScheme.File:
                        return UrlScheme.File;
                    default:
                        // throw ?
                        return s;
                }
            }
        }
    ]);
    return Url;
}();
_define_property(Url, "regex", /^(?:([a-z]*:)\/\/|)([^\s/?]*)(?:\/|)(.*?|)(?:\?(.*)|)$/);

//# sourceMappingURL=url.js.map